export default __webpack_public_path__ + "static/media/cunningdefletction.9383dc2a.png";